import { render } from "./CatalogueClientList.vue?vue&type=template&id=75c1b8e4&scoped=true"
import script from "./CatalogueClientList.vue?vue&type=script&lang=js"
export * from "./CatalogueClientList.vue?vue&type=script&lang=js"

import "./CatalogueClientList.vue?vue&type=style&index=0&id=75c1b8e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c1b8e4"]])

export default __exports__